import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { ModalService } from 'src/modules/base/services/modal.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';

@Component({
    selector: 'app-abha-card',
    templateUrl: './abha-card.component.html',
    styleUrls: ['./abha-card.component.scss'],
    standalone: false
})
export class AbhaCardComponent implements OnInit {
  data: any;
  permission: any; 
  landingUrl: any;

  constructor(
    private dialog: DialogConfig,
    private baseService: BaseService,
    private dialogRef: DialogRef,
    public appService: AppService,
    public authenticationService: AuthenticationService,
    public rolePermissionService: RolePermissionService,
    private alerts: AlertsService,
    public modal: ModalService,
    public router: Router,
  ) { }

  ngOnInit(){
    this.permission = this.rolePermissionService.checkAccessPermission("abha_card_ganerate", "patient", "patient-registration");
    if(!this.permission && this.appService._currentSessionData){
      this.landingUrl = (this.appService._currentSessionData.dashboardUrlFound != undefined) ? this.appService._currentSessionData.dashboardUrlFound : this.appService._appData.DEFAULT_APPLICATION + '/dashboard';
      this.router.navigate([this.landingUrl]);
    }
    if(this['dialog'] && this['dialog'].data){
      this.data = this['dialog'].data.item
    }
  }

  saveData(event: any){
    if(event != 'deLink'){
      this.router.navigate([`/account-management/health-card`], { queryParams: { key: this.authenticationService.getUserType() != 'patient' ? this.data.id : this.authenticationService.getCurrentUser().user_id, event: event, returnUrl: this.router.url } })
      this.dialogRef.close();
      return
    } else {
      const dialogref = this.modal.confirm("De-Link Abha Card", "Are you sure, You want to De-Link")
      dialogref.subscribe(popupValue => {
          if (popupValue) {
            let data = {
              "id": this.authenticationService.getUserType() != 'patient' ? this.data.id : this.authenticationService.getCurrentUser().user_id
            }
            this.baseService.action(data, 'ABDM_UNLINK', 'patient-registration', 'patient').subscribe((result) => {
              if (result.errCode == 0) {
                this.alerts.info(result.message);
                this.dialogRef.close();
              }
              else {
                this.alerts.error(result.message);
              }
        
            });
          }
      })
    }
  }

}
